module.exports = __webpack_public_path__ + "img/white-thread.f65b09b0.png";